import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const useDisableBack = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Create stronger history trap
    window.history.pushState(null, "", location.href);

    const handlePopState = () => {
      // Immediately push again
      window.history.pushState(null, "", location.href);

      // Force navigation
      navigate(location.pathname + location.search, { replace: true });
    };

    // Extra safety: detect visibility change (Safari fix)
    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        window.history.pushState(null, "", location.href);
      }
    };

    window.addEventListener("popstate", handlePopState);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [location.pathname, location.search]);
};

export default useDisableBack;
